import { assert_number_gt, assert_number_gte_0, assert_string_not_empty, assert_type_array_enum, assert_type_boolean } from '@shared/asserts/utils_asserts';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTO__workspace_user extends DTO__database_entity {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.WORKSPACE_USER;

  //STATIC METHODS

  static sort_by_name(a: DTO__workspace_user, b: DTO__workspace_user) {
    return a.full_name.localeCompare(b.full_name);
  }

  /*
   * DB FIELDS
   */
  user_id!: string;
  workspace_id!: string;

  full_name!: string;
  url_relative_avatar!: string;

  last_online_at!: number;

  credits_limit_enabled!: boolean;
  credits_limit!: number;
  credits_per_month_used!: number;

  permissions: string[];

  /*
   * METHODS
   */
  constructor() {
    super();
    this.permissions = [];
  }

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_string_not_empty(this.user_id);
    assert_string_not_empty(this.workspace_id);

    assert_string_not_empty(this.full_name);

    assert_number_gt(this.last_online_at, 0);

    assert_type_boolean(this.credits_limit_enabled);
    assert_number_gte_0(this.credits_limit);
    assert_number_gte_0(this.credits_per_month_used);

    assert_type_array_enum(this.permissions, ENUM__workspace_entity_feature);
  }

  is_feature_pertmitted(feature: ENUM__workspace_entity_feature): boolean {
    //todo:remove
    return true;
    return this.permissions.includes(feature);
  }

  is_sharing_permitted(): boolean {
    return (
      this.permissions.includes(ENUM__workspace_entity_feature.ENTITY_USER_TASK_SHARE) ||
      this.permissions.includes(ENUM__workspace_entity_feature.ENTITY_COLLECTION_SHARE) ||
      this.permissions.includes(ENUM__workspace_entity_feature.ENTITY_SEARCH_SHARE)
    );
  }
}
